// extracted by mini-css-extract-plugin
export default {"button":"Mv0Z1","link":"cxQhX","container":"_5kx6L","mobile-container":"MOUH6","mobileContainer":"MOUH6"};